import React, { useEffect, useMemo, useState } from 'react';
import { ConfigProvider, Menu, MenuProps } from 'antd';
import './style.css';
import { useMenuRSStateStore } from '../../../../store/rightSideMenuState/menuRSStateStore';

interface MenuRSProps {
    fileCount?: number;
}

const FileMenuItem = ({ count }: { count: number }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <span>Файлы</span>
        <span className={'headline small'} style={{ color: 'var(--gray-02)', marginLeft: 8 }}>
            ({count})
        </span>
    </div>
);

const MenuRS: React.FC<MenuRSProps> = ({ fileCount = 0 }) => {
    const { selectedStateMenuRS, setSelectedStateMenuRS } = useMenuRSStateStore();
    const [current, setCurrent] = useState(selectedStateMenuRS || 'map');

    useEffect(() => {
        if (selectedStateMenuRS) {
            setCurrent(selectedStateMenuRS);
        } else {
            setCurrent('map');
        }
    }, [selectedStateMenuRS]);

    const items = useMemo<MenuProps['items']>(
        () => [
            {
                label: 'Карта',
                key: 'map',
            },
            {
                label: <FileMenuItem count={fileCount} />,
                key: 'files',
            },
        ],
        [fileCount],
    ); // Зависимость от fileCount

    const onClick: MenuProps['onClick'] = (e) => {
        console.log('click ', e.key);
        setCurrent(e.key);
        setSelectedStateMenuRS(e.key);
    };

    return (
        <div className="MenuRS">
            <ConfigProvider
                theme={{
                    components: {
                        Menu: {
                            itemPaddingInline: 0,
                            horizontalItemSelectedColor: '#FCE49C',
                            activeBarHeight: 4,
                        },
                    },
                }}
            >
                <Menu
                    className="menuLine"
                    onClick={onClick}
                    selectedKeys={[current]}
                    mode="horizontal"
                    items={items}
                />
            </ConfigProvider>
        </div>
    );
};

export default MenuRS;
